export default {
  computed: {
    loginRules() {
      return {
        tel: [{ validator: this.checkTel, trigger: 'blur' }],
        password: [
          {
            required: true,
            message: this.$t('login.error.empty'),
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: this.$t('login.error.empty'),
            trigger: 'blur'
          }
        ],
        captcha: [
          {
            required: true,
            message: this.$t('login.error.empty'),
            trigger: 'blur'
          }
        ],
        email: [{ validator: this.checkEmail, trigger: 'blur' }]
      }
    },
    registerRules() {
      return {
        tel: [{ validator: this.checkTel, trigger: 'blur' }],
        email: [{ validator: this.checkEmail, trigger: 'blur' }],
        code: [
          {
            required: true,
            message: this.$t('login.error.empty'),
            trigger: 'blur'
          }
        ],
        password_1: [{ validator: this.checkPwd, trigger: 'blur' }],
        password_2: [{ validator: this.checkPwd2, trigger: 'blur' }]
      }
    }
  },
  methods: {
    checkTel(rule, value, callback) {
      if (this.mode === 'email') return callback()
      if (!value || !value.phone || !value.code) {
        callback(this.$t('login.error.empty'))
      }
      callback()
    },
    checkEmail(rule, value, callback) {
      callback = callback || function() {}
      if (this.mode === 'phone') {
        callback()
        return true
      }
      if (!value) {
        callback(this.$t('login.error.empty'))
        return false
      }
      if (value && value.indexOf('@') === -1) {
        callback(this.$t('login.error.email'))
        return false
      }
      callback()
      return true
    },
    checkPwd(rule, password, callback) {
      if (!password) {
        callback(this.$t('login.error.empty'))
      } else {
        if (password.length < 8 || password.length > 24) {
          callback(this.$t('login.error.password-length'))
        }
        const passwordRegExArr = [
          [/\d+/, 1],
          [/[a-z]+/, 0.5],
          [/[A-Z]+/, 0.5],
          [/[!@#$%^&*()_+=-]+/, 1]
        ]
        let passwordScore = 0
        passwordRegExArr.map(reg => {
          const conditionCheck = reg[0].test(password)
          if (conditionCheck) {
            passwordScore += reg[1]
          }
        })
        if (passwordScore <= 1) {
          callback(this.$t('login.error.password-strength'))
        }
      }
      callback()
    },
    checkPwd2(rule, password, callback) {
      if (!password) {
        callback(this.$t('login.error.empty'))
      } else {
        if (password !== this.body.password_1) {
          callback(this.$t('login.error.password-diff'))
        }
      }
      callback()
    }
  }
}
